import {MaskState} from "../../interfaces/store/reducers/mask";
import {SetExternalUrlLoadingAction, SetLoadingAction} from "../../interfaces/store/actions/mask";
import {SET_EXTERNAL_URL_LOADING, SET_LOADING} from "../actions/availableActions";

const initialState: MaskState = {
    isLoading: false,
    isExternalUrlLoading: false,
};

type AvailableActions = SetLoadingAction | SetExternalUrlLoadingAction;

const maskReducer = (state: MaskState = initialState, action: AvailableActions): MaskState => {
    switch (action.type) {
        case SET_LOADING:
            return {
                ...state,
                isLoading: action.payload,
            };
        case SET_EXTERNAL_URL_LOADING:
            return {
                ...state,
                isExternalUrlLoading: action.payload,
            };
        default:
            return state;
    }
};

export default maskReducer;
